/**
 * Labstep
 *
 * @module components/Entity/Can
 * @desc Component to determine if user has permissions for certain action
 */

import {
  useHasAccess,
  useHasAccessCreate,
  useHasAccessGroup,
} from './hooks';
import type {
  CanCreateProps,
  CanGroupProps,
  CanProps,
} from './types';

export const CanCreate: RFC<CanCreateProps> = ({
  parentName,
  parentId,
  entityName,
  children,
}) =>
  useHasAccessCreate(entityName, parentName, parentId)
    ? children
    : null;

export const CanGroup: RFC<CanGroupProps> = ({
  action,
  groupId,
  children,
}) => (useHasAccessGroup(action, groupId) ? children : null);

export const Can: RFC<CanProps> = ({
  entityName,
  id,
  action,
  children,
  field,
}) => (useHasAccess(entityName, id, action, field) ? children : null);
